import { useEffect } from 'react';
import { Modal } from './components.jsx';
import { fmtMin } from './lib/format.js';

// Shown once per user at the start of a new ISO week, summarising their
// place in last week's tracking ranking. Confetti for #1.
function AwardCeremonyModal({ rank, totalRanked, percent, totalMinutes, weekKey, onClose, onConfetti }) {
  useEffect(() => {
    if (rank === 1) onConfetti?.();
  }, [rank, onConfetti]);

  let title, sub, emoji, accent;
  if (rank === 1) {
    title = 'Platz 1 — Glückwunsch!';
    sub = `Du hast letzte Woche ${percent}% deiner Arbeitszeit erfasst und damit das ganze Team getoppt.`;
    emoji = '🥇';
    accent = 'var(--accent)';
  } else if (rank === 2) {
    title = 'Platz 2 letzte Woche';
    sub = `${percent}% Tracking-Quote — knapp am Gold vorbei. Diese Woche neuer Anlauf?`;
    emoji = '🥈';
    accent = 'var(--ink-2)';
  } else if (rank === 3) {
    title = 'Platz 3 letzte Woche';
    sub = `${percent}% Tracking-Quote — solides Bronze. Top.`;
    emoji = '🥉';
    accent = 'var(--warn)';
  } else {
    title = `Platz ${rank} von ${totalRanked} letzte Woche`;
    sub = `${percent}% Tracking-Quote · ${fmtMin(totalMinutes)} erfasst. Diese Woche schaffst du mehr.`;
    emoji = '📊';
    accent = 'var(--ink-3)';
  }

  return (
    <Modal onClose={onClose}>
      <div style={{ padding: '40px 32px 28px', textAlign: 'center', maxWidth: 480 }}>
        <div className="eyebrow">{weekKey} · Wochenrückblick</div>
        <div style={{
          fontSize: 84, lineHeight: 1, margin: '20px 0 16px',
          animation: 'pop 380ms cubic-bezier(0.2,0.8,0.2,1)',
        }}>{emoji}</div>
        <h2 className="serif" style={{
          fontSize: 28, fontWeight: 500, margin: 0, letterSpacing: '-0.01em',
          color: accent,
        }}>
          {title}
        </h2>
        <p className="muted" style={{ fontSize: 14, marginTop: 14, lineHeight: 1.55, padding: '0 16px' }}>
          {sub}
        </p>
        <button className="btn btn-primary" style={{ marginTop: 28, padding: '10px 24px' }} onClick={onClose}>
          Los geht's
        </button>
      </div>
    </Modal>
  );
}

export { AwardCeremonyModal };
